import {
	Container as ContainerMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './container.scss';

export interface ContainerProps extends ChildrenProps<HTMLDivElement> {
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const Container = ({
	className,
	...rest
}: ContainerProps) => {
	return (
		<ContainerMui
			{...rest}
			className={appendClassName('sm-container', className)}/>
	)
}

export default Container;